var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttach({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1333 21C8.70222 21 7.48889 20.52 6.49333 19.56C5.49778 18.6 5 17.43 5 16.05V6.6C5 5.61 5.36556 4.7625 6.09667 4.0575C6.82778 3.3525 7.70667 3 8.73333 3C9.76 3 10.6389 3.3525 11.37 4.0575C12.1011 4.7625 12.4667 5.61 12.4667 6.6V13.8H11.0667V6.6C11.0667 5.97 10.8411 5.4375 10.39 5.0025C9.93889 4.5675 9.38667 4.35 8.73333 4.35C8.08 4.35 7.52778 4.5675 7.07667 5.0025C6.62556 5.4375 6.4 5.97 6.4 6.6V16.05C6.4 17.04 6.76556 17.8875 7.49667 18.5925C8.22778 19.2975 9.10667 19.65 10.1333 19.65C10.5844 19.65 11.0085 19.5786 11.4055 19.4358C11.8024 19.293 12.1562 19.0944 12.4667 18.84V20.46C12.1089 20.625 11.7356 20.7564 11.3467 20.8542C10.9578 20.952 10.5533 21.0006 10.1333 21ZM14.3333 20.1V17.4H11.5333V15.6H14.3333V12.9H16.2V15.6H19V17.4H16.2V20.1H14.3333ZM10.1333 16.05V17.4C9.48 17.4 8.92778 17.1825 8.47667 16.7475C8.02556 16.3125 7.8 15.78 7.8 15.15V6.6H9.2V15.15C9.2 15.405 9.2896 15.6189 9.4688 15.7917C9.648 15.9645 9.86951 16.0506 10.1333 16.05ZM13.8667 11.1V6.6H15.2667V11.1H13.8667Z",
    fill: "#45484A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttach);
export default __webpack_public_path__ + "static/media/Attach.1885acbaa9e53123ba0f27c5b7523bb5.svg";
export { ForwardRef as ReactComponent };